import useTranslations from "@/hooks/useTranslations";

type HowItWorksStep = {
    title: string,
    description: string,
}

export type HowItWorksProps = {
    steps: [HowItWorksStep, HowItWorksStep, HowItWorksStep],
    title: string
}

export default function ({steps: [step1, step2, step3], title }: HowItWorksProps) {
    const { __ } = useTranslations();

    return (
        <section className="bg-gray-50 dark:bg-gray-800 py-14 my-10">
            <div className="container mx-auto">

                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 ">

                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5">
                        <div className="text-center mb-10">
                            <h2 className="text-3xl font-extrabold tracking-tight text-gray-900 dark:text-gray-100 sm:text-4xl">
                                {title}
                            </h2>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">

                            <div
                                className="flex flex-col items-center p-6 text-center bg-white dark:bg-gray-900 rounded-lg border dark:border-gray-700 shadow-md">
                                <div className="flex items-center justify-center w-10 h-10 bg-red-100 dark:bg-red-900 rounded-lg mb-2">
                                    <span className="text-xl font-bold text-red-600 dark:text-red-300">1</span>
                                </div>
                                <h3 className="mb-2 text-xl font-bold text-gray-900 dark:text-gray-100">{step1.title}</h3>
                                <p className="font-normal text-gray-700 dark:text-gray-300">{step1.description}</p>
                            </div>


                            <div
                                className="flex flex-col items-center p-6 text-center bg-white dark:bg-gray-900 rounded-lg border dark:border-gray-700 shadow-md">
                                <div className="flex items-center justify-center w-10 h-10 bg-blue-100 dark:bg-blue-900 rounded-lg mb-2">
                                    <span className="text-xl font-bold text-blue-600 dark:text-blue-300">2</span>
                                </div>
                                <h3 className="mb-2 text-xl font-bold text-gray-900 dark:text-gray-100">{step2.title}</h3>
                                <p className="font-normal text-gray-700 dark:text-gray-300">{step2.description}</p>
                            </div>


                            <div
                                className="flex flex-col items-center p-6 text-center bg-white dark:bg-gray-900 rounded-lg border dark:border-gray-700 shadow-md">
                                <div
                                    className="flex items-center justify-center w-10 h-10 bg-green-100 dark:bg-green-900 rounded-lg mb-2">
                                    <span className="text-xl font-bold text-green-600 dark:text-green-300">3</span>
                                </div>
                                <h3 className="mb-2 text-xl font-bold text-gray-900 dark:text-gray-100">{step3.title}</h3>
                                <p className="font-normal text-gray-700 dark:text-gray-300">{step3.description}</p>
                            </div>
                        </div>
                    </div>


                </div>

            </div>
        </section>
    )
}
